var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDedicacao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10579 2.80419C2.62804 2.25652 3.17582 53.1999 8.10579 53.1998C13.0358 53.1997 50.8325 32.3841 50.8325 28.002C50.8325 23.6198 13.5835 3.35186 8.10579 2.80419Z",
    fill: "#E9EFF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8484 17.1281L42.375 18.8578L37.875 10.2515L41.3906 8.49373C41.6519 8.36055 41.9552 8.33608 42.2345 8.42565C42.5137 8.51521 42.7462 8.71155 42.8813 8.97185L46.3406 15.5953C46.4108 15.7279 46.4537 15.8732 46.4669 16.0226C46.4801 16.172 46.4632 16.3225 46.4174 16.4654C46.3715 16.6082 46.2976 16.7404 46.1998 16.8542C46.1021 16.968 45.9827 17.0611 45.8484 17.1281V17.1281Z",
    stroke: "url(#paint0_linear_5_100)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 18.7173L14.1516 16.9735C14.0178 16.908 13.8986 16.8162 13.8011 16.7037C13.7035 16.5912 13.6296 16.4602 13.5837 16.3185C13.5377 16.1768 13.5208 16.0273 13.5338 15.8789C13.5468 15.7306 13.5895 15.5863 13.6594 15.4548L17.1188 8.83136C17.2541 8.57125 17.4856 8.37425 17.764 8.28231C18.0425 8.19038 18.3458 8.21078 18.6094 8.33917L22.125 10.097L17.625 18.7173Z",
    stroke: "url(#paint1_linear_5_100)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.375 18.8577L40.125 21.5014L34.95 26.6764C34.809 26.8083 34.6381 26.9041 34.4519 26.9555C34.2658 27.0069 34.07 27.0125 33.8813 26.9717L25.725 24.9327C25.576 24.8911 25.4372 24.8193 25.3172 24.7217L17.625 18.717",
    stroke: "url(#paint2_linear_5_100)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1251 21.5017L33.9376 17.0017L32.1376 18.3517C31.3578 18.9338 30.4107 19.2482 29.4376 19.2482C28.4645 19.2482 27.5175 18.9338 26.7376 18.3517L25.9782 17.7752C25.8498 17.6775 25.7436 17.5537 25.6666 17.412C25.5897 17.2702 25.5437 17.1137 25.5317 16.9529C25.5197 16.792 25.5421 16.6304 25.5972 16.4789C25.6524 16.3273 25.7391 16.1891 25.8517 16.0736L31.3642 10.5752C31.4677 10.4721 31.5906 10.3905 31.7257 10.335C31.8609 10.2795 32.0056 10.2512 32.1517 10.2517H37.8751",
    stroke: "url(#paint3_linear_5_100)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2092 10.0968L29.4233 7.98744C29.6796 7.91393 29.9537 7.93386 30.1967 8.04369L35.0624 10.2515",
    stroke: "url(#paint4_linear_5_100)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 29.9391L23.5172 28.8703C23.3447 28.8313 23.185 28.7491 23.0531 28.6313L19.875 25.875",
    stroke: "url(#paint5_linear_5_100)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_100",
    x1: 37.875,
    y1: 13.6152,
    x2: 46.4712,
    y2: 13.6152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CFCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_100",
    x1: 13.5295,
    y1: 13.4714,
    x2: 22.125,
    y2: 13.4714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CFCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_100",
    x1: 17.625,
    y1: 22.8579,
    x2: 42.375,
    y2: 22.8579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CFCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_100",
    x1: 25.5286,
    y1: 15.8767,
    x2: 40.1251,
    y2: 15.8767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CFCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_100",
    x1: 22.2092,
    y1: 9.09767,
    x2: 35.0624,
    y2: 9.09767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CFCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_100",
    x1: 19.875,
    y1: 27.907,
    x2: 27.75,
    y2: 27.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AFAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56CFCE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDedicacao);
export default __webpack_public_path__ + "static/media/icon-dedicacao.c0ede3d2369041c2bda3a3f6307628bb.svg";
export { ForwardRef as ReactComponent };